// extracted by mini-css-extract-plugin
export default {"box":"_52m9zfmPqKW+kTRMQC4uFw==","mask":"EDcu5U0n6spupyVtWTj7Mg=="};